import { useEffect, useState } from 'react';
import { AnalyticsWebClient, CommunityAnalyticsClient } from '@atlassian/community-library';
import { ENVIRONMENT, getEnvironment } from '../utils/environment';
import { useOneTrustContext } from 'utils/onetrust-provider';

interface Props {
  userId: string;
}

export const useInitializeAnalyticsClient = ({ userId }: Props) => {
  const { analyticsOptOut, onetrustActiveGroups } = useOneTrustContext();
  const [analyticsClient, setAnalyticsClient] = useState<AnalyticsWebClient | undefined>(undefined);

  useEffect(() => {
    if (analyticsOptOut) {
      return;
    }

    const client = CommunityAnalyticsClient.initWithPageAnalytics(
      CommunityAnalyticsClient.SUB_APP.HOME,
      null,
      getEnvironment() as ENVIRONMENT,
      {},
      userId,
    );

    setAnalyticsClient(client);
  }, [analyticsOptOut, onetrustActiveGroups, userId]);

  return { analyticsClient };
};
